import en from './en';
import flattenMessages from '../helpers/flattenMessages';

export default flattenMessages(en);
export const locale = 'en';
